import { render, staticRenderFns } from "./channelPage.vue?vue&type=template&id=a8a3fc0e&scoped=true&"
import script from "./channelPage.vue?vue&type=script&lang=js&"
export * from "./channelPage.vue?vue&type=script&lang=js&"
import style0 from "./channelPage.vue?vue&type=style&index=0&id=a8a3fc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a3fc0e",
  null
  
)

/* custom blocks */
import block0 from "./channelPage.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports